import { render, staticRenderFns } from "./ModalStaff.vue?vue&type=template&id=d22cd2ca&scoped=true&"
import script from "./ModalStaff.vue?vue&type=script&lang=js&"
export * from "./ModalStaff.vue?vue&type=script&lang=js&"
import style0 from "./ModalStaff.vue?vue&type=style&index=0&id=d22cd2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22cd2ca",
  null
  
)

export default component.exports